import React from 'react';
import classNames from 'classnames';

import css from './IconReview.module.css';

/**
 * Review star icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean?} props.isFilled is filled with color
 * @returns {JSX.Element} SVG icon
 */
const IconReview = props => {
  const { className, rootClassName, isFilled } = props;
  const filledOrDefault = isFilled ? css.filled : css.root;
  const classes = classNames(rootClassName || filledOrDefault, className);

  return isFilled ? (
    <svg
      className={classes}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" transform="translate(0 0.500305)" fill="#219653" />
      <path
        d="M10 14.1764L13.0417 13.3619L14.3125 17.5003L10 14.1764ZM17 8.82735H11.6458L10 3.50031L8.35417 8.82735H3L7.33334 12.1292L5.6875 17.4563L10.0208 14.1544L12.6875 12.1292L17 8.82735Z"
        fill="white"
      />
    </svg>
  ) : (
    <svg
      className={classes}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" transform="translate(0 0.500305)" fill="#219653" />
      <path
        d="M10 14.1764L13.0417 13.3619L14.3125 17.5003L10 14.1764ZM17 8.82735H11.6458L10 3.50031L8.35417 8.82735H3L7.33334 12.1292L5.6875 17.4563L10.0208 14.1544L12.6875 12.1292L17 8.82735Z"
        fill="white"
      />
    </svg>
  );
};

export default IconReview;
